import { render, staticRenderFns } from "./PersonalWhatsapp.vue?vue&type=template&id=388fda1b&scoped=true&"
import script from "./PersonalWhatsapp.vue?vue&type=script&lang=js&"
export * from "./PersonalWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./PersonalWhatsapp.vue?vue&type=style&index=0&id=388fda1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388fda1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388fda1b')) {
      api.createRecord('388fda1b', component.options)
    } else {
      api.reload('388fda1b', component.options)
    }
    module.hot.accept("./PersonalWhatsapp.vue?vue&type=template&id=388fda1b&scoped=true&", function () {
      api.rerender('388fda1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/PersonalWhatsapp.vue"
export default component.exports